// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"5feb2d01","713":"eef991b1"}[chunkId] + ".chunk.css";
};